// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"facbb566","235":"4fc06222","289":"9083e19a","330":"49c5c357","471":"fd6b640a","730":"33a924c0"}[chunkId] + ".chunk.js";
};